import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import { Provider } from "react-redux";
import store from "./dataManagement/uiDb/UiDb";
import { isNativeWebView } from "./services/helpers/platform";
import { installNativeBridge } from "./services/native/nativeBridge";

// Install window.NineFindsNative immediately — before React mounts and before
// the native app calls into it — so it never sees `undefined`.
installNativeBridge();



ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// Service worker policy:
// - Inside a native WebView (Android/iOS): NO service worker. It can serve a
//   stale bundle and fire unauthenticated requests; push is handled natively.
//   Also unregister any SW a previous build left behind.
// - In a production browser: register the Workbox PWA worker as usual.
// (vite-plugin-pwa only emits /sw.js on a production build, hence the PROD gate.)
if ('serviceWorker' in navigator) {
  if (isNativeWebView()) {
    // No service worker in the app. Unregister any a previous build left behind,
    // and if one is actually controlling this load (serving a stale bundle /
    // firing its old web-push 401), reload ONCE so it stops. The sessionStorage
    // flag prevents a reload loop. This lets existing devices self-heal without
    // a manual clear.
    navigator.serviceWorker
      .getRegistrations?.()
      .then((regs) => {
        if (!regs.length) return;
        const hadController = !!navigator.serviceWorker.controller;
        Promise.all(regs.map((r) => r.unregister())).then(() => {
          if (hadController && !sessionStorage.getItem('nine_sw_cleared')) {
            sessionStorage.setItem('nine_sw_cleared', '1');
            window.location.reload();
          }
        });
      })
      .catch(() => { });
  } else if (import.meta.env.PROD) {
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register(
          '/sw.js',
          { scope: '/' }
        );
        console.log('Service Worker registered:', registration);
      } catch (error) {
        console.error('Service Worker registration failed:', error);
      }
    });
  }
}
